var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 21c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 0 1 3.5 19V5c0-.55.196-1.02.588-1.412A1.93 1.93 0 0 1 5.5 3h6c.283 0 .521.096.713.288.192.192.288.43.287.712 0 .283-.097.52-.288.713A.957.957 0 0 1 11.5 5h-6v14h6c.283 0 .521.096.713.288.192.192.288.43.287.712 0 .283-.097.52-.288.713A.957.957 0 0 1 11.5 21h-6Zm12.175-8H10.5a.965.965 0 0 1-.712-.288A.972.972 0 0 1 9.5 12c0-.283.095-.52.288-.712A.97.97 0 0 1 10.5 11h7.175L15.8 9.125a.918.918 0 0 1-.275-.675c0-.267.092-.5.275-.7a.95.95 0 0 1 .7-.313.943.943 0 0 1 .725.288L20.8 11.3c.2.2.3.433.3.7 0 .267-.1.5-.3.7l-3.575 3.575c-.2.2-.437.296-.712.288a1.019 1.019 0 0 1-.713-.313.97.97 0 0 1-.262-.712.984.984 0 0 1 .287-.688l1.85-1.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutRounded);
export default __webpack_public_path__ + "static/media/logout-rounded.4ee1a1f153e694aa148cad8ff8d9e2f2.svg";
export { ForwardRef as ReactComponent };